import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {MatchLiveData} from 'utils/types';
import {AppState} from 'store/types';
import getMatchLiveDataByIdThunk from 'store/live/actions/getMatchLiveDataById';

/**
 * Return type of the useMatchLiveData hook
 */
type UseMatchLiveDataResult = [
  {loading: boolean, data?: MatchLiveData, error?: string | boolean},
  {getMatchLiveDataById: typeof getMatchLiveDataByIdThunk}
]

/**
 * Selects the 'live' state and sum it up into a referring object
 */
const matchLiveDataSelector = (state: AppState) => ({
  loading: state.live.isFetching,
  data: state.live.data,
  error: state.live.didInvalidate ? state.matches.error : false,
});

/**
 * Wraps up the business logic of selecting the 'matchLiveData' state.
 */
const useMatchLiveData = (): UseMatchLiveDataResult => {
  const dispatch = useDispatch();
  const state = useSelector(matchLiveDataSelector);

  const getMatchLiveDataById = useCallback((id: string) => dispatch(getMatchLiveDataByIdThunk(id)), [dispatch]);

  return [state, {getMatchLiveDataById}];
};


export default useMatchLiveData;
